quoteModule.factory('contractInfoService', [
    function () {
        var contractInfoService = {};
        //This service holds the contracts flags and summary info
        contractInfoService.contractsPerQuote = {};
        contractInfoService.contractInfo = {};
        contractInfoService.quoteQueueInfo = {
            currentScenarioId : 0,
            currentScenarioQuotes : [],
            currentScenarioContracts : [],
            allowContracting : {},
            showQueue: false,
            priceEditing : {},
            profitCostMode : {},
            statuses: {},
            selectedQuotes : [],
            loading: {},
            bankInfoRequired: {}
        };
        contractInfoService.contractErrMsgPerQuote = {};

        contractInfoService.getScenarioQuoteById = function(id) {
            var quote = contractInfoService.quoteQueueInfo.currentScenarioQuotes.filter(function(element) {
                return element.RatedTerms[0].SavedRateUniqueId == id;
            });

            return quote[0] || null;
        };

        contractInfoService.clearQuoteQueueInfo = function() {
            contractInfoService.contractErrMsgPerQuote = {};
            contractInfoService.quoteQueueInfo.currentScenarioId = 0;
            contractInfoService.quoteQueueInfo.currentScenarioQuotes = [];
            contractInfoService.quoteQueueInfo.currentScenarioContracts = [];
            contractInfoService.quoteQueueInfo.showQueue = false;
            contractInfoService.quoteQueueInfo.priceEditing = {};
            contractInfoService.quoteQueueInfo.profitCostMode = {};
            contractInfoService.quoteQueueInfo.selectedQuotes = [];
            contractInfoService.quoteQueueInfo.loading = {};
            contractInfoService.quoteQueueInfo.bankInfoRequired = {};
        };

        contractInfoService.contractProductInfo = {
            keycareContractPrefix : '', // If non-empty, contract Num must have this as a prefix
            keycareContractNum : '',
            keycareContractLength: '',  // If non-empty, contract Num must be this length
            etchStencilNum : '',
            etchNum : '',
            etchSecNum :'',
            amountFinanced : 0
        };

        contractInfoService.clearContractProductInfo = function() {
            for(var prop in contractInfoService.contractProductInfo) {
                if(contractInfoService.contractProductInfo.hasOwnProperty(prop)) {
                    contractInfoService.contractProductInfo[prop] = null;
                }
            }
        };

        contractInfoService.requiredFields = {
            customer : [],
            contract: [],
            lender: [],
            deal: [],
            vehicle: [],
            rv:[]
        };

        contractInfoService.validFields = {
            customer : [],
            contract: [],
            lender: [],
            deal: [],
            vehicle: []
        };

        contractInfoService.clearRequiredFields = function() {
            contractInfoService.requiredFields.customer = [];
            contractInfoService.requiredFields.contract = [];
            contractInfoService.requiredFields.lender = [];
            contractInfoService.requiredFields.deal = [];
            contractInfoService.requiredFields.vehicle = [];
            contractInfoService.requiredFields.rv = [];

            contractInfoService.validFields.customer = [];
            contractInfoService.validFields.contract = [];
            contractInfoService.validFields.lender = [];
            contractInfoService.validFields.deal = [];
            contractInfoService.validFields.vehicle = [];
        };

        contractInfoService.clearQuoteStatuses = function(quoteId){
            contractInfoService.quoteQueueInfo.statuses[quoteId] = null;            
        }
        
        return contractInfoService;
    }]);
